import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Pagination, Mousewheel, Autoplay } from "swiper/modules";
import img01 from '../../images/vi-01.png'
import img02 from '../../images/vi-02.png'
import img03 from '../../images/vi-03.png'
import img04 from '../../images/vi-04.png'
import img05 from '../../images/vi-05.png'
import "swiper/css";
import "swiper/css/pagination";

SwiperCore.use([Pagination, Mousewheel, Autoplay]);

const HorizontalSlider = () => {
  const swiperRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      const handleWheel = (e) => {
        const swiper = swiperRef.current?.swiper;
        const swiperContainer = document.querySelector(".mySwiper");

        if (!swiper || !swiperContainer) return;

        const rect = swiperContainer.getBoundingClientRect();
        const isVisible =
          rect.top < window.innerHeight && rect.bottom > 0;

        if (e.deltaY < 0 && isVisible && swiper.isEnd) {
          swiper.mousewheel.enable();
        }

        if (e.deltaY > 0 && isVisible && swiper.isBeginning) {
          swiper.mousewheel.enable();
        }
      };

      window.addEventListener("wheel", handleWheel, { passive: true });

      return () => {
        window.removeEventListener("wheel", handleWheel);
      };
    }
  }, [isMobile]);

  const slides = [
    {
      img: img01,
      title: "Medicine Delivery",
      subtitle: "Healing Beyond Borders.",
      desc: `Deliver essential medicines across borders — fast, safe, and compliant. With end-to-end tracking, temperature-sensitive handling, and global reach, ParcelX ensures your critical shipments arrive on time, every time.`,
    },
    {
      img: img02,
      title: "Artificial Jewellery",
      subtitle: "From Your Store to the World.",
      desc: `ParcelX makes it easy to take your artificial jewellery brand global. With reliable shipping to over 220+ countries, you can reach customers worldwide without worrying about logistics. Each shipment is handled with care, ensuring your jewellery arrives safe, secure, and on time.`,
    },
    {
      img: img03,
      title: "Pet Care",
      subtitle: "Care That Crosses Borders",
      desc: `ParcelX helps you ship pet care products worldwide — safely, swiftly, and stress-free. From grooming essentials to wellness items, every parcel is packed with care and delivered with love to 220+ countries.`,
    },
    {
      img: img04,
      title: "Festive Gifting",
      subtitle: "Celebrate Across Borders.",
      desc: `With ParcelX, festive gifting goes global. Ship sweets, souvenirs, hampers, and heartfelt surprises to 220+ countries with ease.`,
    },
    {
      img: img05,
      title: "Handicraft Shipping",
      subtitle: "Crafted Here. Loved Everywhere.",
      desc: `ParcelX helps your handcrafted creations reach admirers across 220+ countries. With secure, trackable shipping and careful handling, your art travels the world just as beautifully as it was made.`,
    },
  ];

  return (
    <div className="swiper mySwiper">
      <Swiper
        ref={swiperRef}
        direction={isMobile ? "horizontal" : "vertical"}
        slidesPerView={1}
        spaceBetween={30}
        loop={false}
        speed={800}
        pagination={{ clickable: true }}
        autoplay={{
            delay: 9000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        }}
        mousewheel={
          isMobile
            ? false
            : {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
              }
        }
        modules={[Pagination, Mousewheel, Autoplay]}
        className="mySwiper"
        onReachEnd={(swiper) => {
          if (!isMobile) swiper.mousewheel.disable();
        }}
        onReachBeginning={(swiper) => {
          if (!isMobile) swiper.mousewheel.disable();
        }}
        onSlideChange={(swiper) => {
          if (!isMobile && !swiper.isEnd && !swiper.isBeginning) {
            swiper.mousewheel.enable();
          }
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="slider">
            <div className="row align-items-center">
              <div className="col-md-4 text-start mb-3">
                <img
                  src={slide.img}
                  className="img-fluid"
                  alt={slide.title}
                />
              </div>
              <div className="col-md-8 text-start">
                <h4 className="heading">
                  <span>{slide.title}:</span> {slide.subtitle}
                </h4>
                <p>{slide.desc}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HorizontalSlider;